<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <chartBars
            class="ma-3"
            v-for="(chart, index) in charts"
            :key="index"
            :vTitle="chart.name"
            :cWidth="chart.width"
            :cSeries="chart.series"
          ></chartBars>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import alertEventBus from "@/eventBus/AlertEventBus";
const chartBars = () => import("@/components/orgApps/charts/chartBars");

export default {
  name: "orgMainDashBoard",
  components: {
    chartBars,
  },
  data() {
    return {
      charts: [],
    };
  },
  methods: {
    async getCharts() {
      if (!this.charts.length) {
        ["DocumentGroup", "DocumentRule", "Employee", "Client"].map(
          async (chartName) => {
            let chart = await this.getChart(chartName);
            if (chart.series.length) {
              this.charts.push(chart);
            }
          }
        );
      }
    },
    async getChart(documentType) {
      let details = this.$store.getters[`get${documentType}Details`];

      // if empty
      if (
        details !== null ||
        (Object.keys(details).length === 0 && details.constructor === Object)
      ) {
        //going backend
        try {
          await this.$store.dispatch(`get${documentType}Details`);
          details = this.$store.getters[`get${documentType}Details`];
        } catch (e) {
          //set alert
          alertEventBus.setAlert({ type: "error", msg: e.message });
          return;
        }
      }

      let dataSeries = [];
      let count = 0;

      if (!!details && !!details.counters && !!details.counters.typeName) {
        const { typeName } = details.counters;
        const reducer = (a, c) => a + c;

        dataSeries = Object.keys(typeName).map((k) => ({
          name: k,
          data: [Object.values(typeName[k].status).reduce(reducer)],
        }));
        count = Object.values(typeName)
          .map((i) => Object.values(i.status).reduce(reducer))
          .reduce(reducer);
      }

      return {
        name: `${documentType} Types. Total: ${count}`,
        series: dataSeries,
      };
    },
  },
  async created() {
    this.getCharts();
  },
};
</script>

<style scoped>
</style>
